<template>
  <b-container fluid class="page__edit-stack h-100">
    <base-loading-state v-if="isLoading" />
    <b-row v-else class="justify-content-center">
      <b-col xl="8" class="container-stack">
        <stack-editor
          v-if="!isLoading"
          ref="stackEditor"
          :is-deletable="true"
          :is-published="false"
          mode="edit"
          :stack="stack"
          @submit:stack="onSubmit"
        />

        <b-col>
          <div class="button-container d-flex mb-u5">
            <b-button
              class="button__create-stack"
              variant="success"
              :disabled="isSubmitting"
              @click="submitForm"
            >
              <b-spinner v-if="isSubmitting" small></b-spinner>
              <span v-else> Save </span>
            </b-button>

            <base-back-to-previous-button
              class="btn__previous-page"
              variant="link"
              :disabled="false"
              @click="$router.push({ name: 'stacks' })"
            />
          </div>
        </b-col>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import StackEditor from './components/StackEditor.vue';
import BaseBackToPreviousButton from '@/components/base-components/BaseBackToPreviousButton.vue';
import Stack from '@/models/Stack';
import BaseLoadingState from '@/components/base-components/BaseLoadingState';
export default {
  components: {
    StackEditor,
    BaseBackToPreviousButton,
    BaseLoadingState
  },
  data() {
    return {
      isSubmitting: false,
      stack: {},
      isLoading: true
    };
  },
  computed: {
    stackId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.fetchStacks();
  },
  methods: {
    async fetchStacks() {
      this.isLoading = true;

      try {
        const { response } = await Stack.api().find(this.stackId);

        this.stack = response.data;
      } catch (error) {
        console.error('Error fetching stacks:', error);
      } finally {
        this.isLoading = false;
      }
    },
    submitForm() {
      this.isSubmitting = true;
      this.$refs.stackEditor.submit();
    },
    async onSubmit(data) {
      if (data) {
        this.$router.push({ name: 'stack-managing' });
      }
      this.isSubmitting = false;
    }
  }
};
</script>

<style lang="scss">
.page__edit-stack {
  padding: 0 20px;
  min-height: 100vh;

  .button-container {
    margin-top: 24px;
    justify-content: left;
  }

  .container-stack {
    max-width: 910px;
    padding: 0;
  }
}
</style>
